import React, { useEffect, useState } from 'react';

import { styled } from '@mui/material/styles';
import { Address, Contact, Copy, Customer, CustomerInfo, EmailBox, Phone, Shipping, ShippingID, ShippingMethod, Users } from '../../Svg';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { exportDataExcel, fomateDate, handleCopy } from '../../utils/fomateDate';
import {

  MenuItem,
  Menu,
  Button,
  Paper,
  Typography,
  Box,
  Divider, Grid,
  Chip
} from "@mui/material";
import OrderDetailsProds from '../../component/ordersComps/OrderDetailsProds';
import { ArrowDropDown, Opacity } from '@mui/icons-material';
import { orderDetailsThunk, setorderrefresh } from '../../redux/orderSlice';
import api from '../../utils/api';
import { toast } from 'react-toastify';
import UserHeader from '../../component/reusable/UserHeader';
import CancelModal from '../../component/reusable/cancelModal/CancelModal';

const StyledGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
}));

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));


const New = styled(Chip)(({ theme }) => ({
  backgroundColor: '#4A4C561A',
  color: '#4A4C56',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Processing = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: '#F86624',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));


const Cancelled = styled(Chip)(({ theme }) => ({
  backgroundColor: '#FFF0EA',
  color: 'red',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Shiped = styled(Chip)(({ theme }) => ({
  backgroundColor: '#EAF8FF',
  color: '#2BB2FE',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const Delivered = styled(Chip)(({ theme }) => ({
  backgroundColor: '#E9FAF7',
  color: '#1A9882',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '14px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));


const ActionCancelButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: '#F43224',
  },
}));


const status = [
  "NEW", "PROCESSING","PENDING", "SHIPPED", "DELIVERED"
]

const OrderDetails = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [cancelModal, setCancelModal] = useState(false)
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const { loading, refresh, orderDetails } = useSelector((state) => state.orders);

  const dispatch = useDispatch()
  const { id } = useParams()

  useEffect(() => {
    dispatch(orderDetailsThunk(id))
  }, [refresh])

  const handleClose = (status) => {
    if (status) {
      changeStatus(status)
    }
    setAnchorEl(null);
  };


  const changeStatus = async (status) => {
    const datas = {
      id: id,
      status: status
    }
    try {
      const { data } = await api.updatOrderStatus(datas)
      if (data) {
        toast.success('status updated succesfully')
        dispatch(setorderrefresh())
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || 'something went wrong')
    } finally {
      setCancelModal(false)
    }
  }



  

  const exportOrderDetails = async () => {

    const exportdata = {
      'id': orderDetails?._id || '-',
      'customer Name': orderDetails?.user?.fullName || '-',
      'Customer Email': orderDetails?.user?.email || '-',
      'productNumbers': orderDetails.products
        .flatMap((product) =>
          product.productDetails?.productOverview?.productNumber || []
        )
        .join(", "),
      'Sub Total': orderDetails?.priceBreakup?.subTotal || '-',
      'Tax': orderDetails?.priceBreakup?.tax || '-',
      'Other Charges' : orderDetails?.priceBreakup?.otherCharges || '-',
      'Total': orderDetails?.priceBreakup?.total || '-',
      'Status': orderDetails?.status || '-',
      'CreatedAt': fomateDate(orderDetails?.createdAt)
    }
    console.log("expo", exportdata);
    // console.log("orderde", orderDetails);

    exportDataExcel([exportdata], "ordersdetails")
  }


  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        Loading....
      </div>
    )
  }

  return (
    <>

      <UserHeader
        index={`Order #${orderDetails?._id}`}
        root="Dashboard"
        buttonText={'Add Vendor'}
        showHeader={'orderDetails'}
        exportData={exportOrderDetails}
      />
      <div style={{ borderLeft: "1px solid #DCDEE3", padding: "10px 20px" }}>
        <div style={{ display: 'flex', justifyContent: "space-between", padding: '20px 0px' }}>
          <div style={{ display: 'flex' }}>
            <Typography
              sx={{
                color: 'rgba(29, 31, 44, 1)',
                fontSize: '20px',
                fontWeight: '600',
                fontFamily: `'Public Sans', sans-serif`,
              }}>
              Order #{orderDetails?._id}
            </Typography>
            <Typography style={{
              marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600",
              color: '#01A1FE',
              background: "#EFF9FF",

            }}>
              {orderDetails?.status === "NEW" ? (
                <New label="New" size="small" />
              ) : orderDetails?.status === "DELIVERED" ? (
                <Delivered label="Delivered" size="small" />
              ) : orderDetails?.status === "PROCESSING" ? (
                <Processing label="Processing" size="small" />
              ) : orderDetails?.status === "CANCELLED" ? (
                <Cancelled label="Cancelled" size="small" />
              ) : (
                <Shiped label="shipped" size="small" />
              )}
            </Typography>
          </div>
          <div>

            <ActionCancelButton
              sx={{
                color: '#fff',
                border: '1px solid #F43224',
                background: '#F43224',
                borderRadius: '8px',
              }}
              onClick={() => setCancelModal(!cancelModal)}
            >Cancel order
            </ActionCancelButton>

            <ActionButton
              onClick={handleClick}
              sx={{
                color: '#667085',
                border: '1px solid #E0E2E7',
                background: '#fff',
                borderRadius: '8px',
              }}
            >
              Status
              <ArrowDropDown />
            </ActionButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => handleClose('')}
              MenuListProps={{
                'aria-labelledby': 'status-button',
              }}
            >
              {
                status?.map((i) => (
                  <MenuItem onClick={() => handleClose(i)}
                    sx={{
                      borderBottom: '1px solid #E6E1E5',
                      fontSize: '14px',
                      color: '#667085',
                      textTransform: 'capitalize'
                    }}>
                    {i}
                  </MenuItem>
                ))
              }


            </Menu>
          </div>
        </div>

        {loading ? <div>Please wait...</div> :
          <Box maxWidth="lg">

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <CustomerInfo />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Customer Info
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: 3, }} display="flex" alignItems="flex-start" >
                    <Customer />
                    <Box style={{ marginLeft: '8px', }}>
                      <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                        Customer
                      </Typography>
                      <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                        {orderDetails?.user?.fullName}
                      </Typography></Box>
                  </Box>
                </Paper>
              </Grid>


              <Grid item xs={12} md={6}>
                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <Contact />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Contact
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <EmailBox />
                      <Box style={{ marginLeft: '8px', }}>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Email
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {orderDetails?.user?.email}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(orderDetails?.user?.email)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Phone />
                      <Box style={{ marginLeft: '8px', }}>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Phone Number
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {orderDetails?.user?.phone}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(orderDetails?.user?.phone)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                </Paper>
              </Grid>

              {/* <Grid item xs={12} md={6}>
                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <Payment />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Payment
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <ShippingID />
                      <Box style={{ marginLeft: '8px', }}>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Payment ID
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          490392238192<br />
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(vendorDetails?.phone)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Billing />
                      <Box style={{ marginLeft: '8px', }}>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Payment Method
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          VISA
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Billing />
                      <Box style={{ marginLeft: '8px', }}>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Billing Address
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {vendorDetails?.billingAddress?.factoryUnits}<br />
                          {vendorDetails?.billingAddress?.streetAddress}, {vendorDetails?.billingAddress?.state},{vendorDetails?.billingAddress?.country} - {vendorDetails?.billingAddress?.zipCode}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Grid> */}

              <Grid item xs={12} md={6}>
                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <Shipping />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Shipping
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <ShippingID />
                      <Box style={{ marginLeft: '8px', }}>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Shipping ID
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          SHP1092311<br />
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(orderDetails?.phone)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <ShippingMethod />
                      <Box style={{ marginLeft: '8px', }}>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Shipping Method
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          Regular
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Address />
                      <Box style={{ marginLeft: '8px', }}>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Shipping Address
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {orderDetails?.address?.factoryUnits}<br />
                          {orderDetails?.address?.streetAddress}, {orderDetails?.address?.state} - {orderDetails?.address?.zipCode},{orderDetails?.address?.country}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            </Grid>

            <OrderDetailsProds
              products={orderDetails?.products}
              price={orderDetails?.priceBreakup}
            />

            <CancelModal
              onDelete={() => changeStatus('CANCELLED')}
              isOpen={cancelModal}
              onClose={() => setCancelModal(false)}
            />
          </Box>
        }
      </div>
    </>
  );
};

export default OrderDetails;
